export function truncateHash(hash) {
    return `${hash.substring(0, 6)}...${hash.substring(hash.length - 4, hash.length)}`;
}
//# sourceMappingURL=contract.js.map